import React from "react";
import imageToAdd from "../assets/images/logo.png";

function Logo() {
   return <img src={imageToAdd} alt="ATP Media" className="atp-media-logo" />;
}

export default Logo;



